export const IMAGES = {
  heroDenver:
    "https://images.unsplash.com/photo-1607570415631-5279aa4e5252?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxkZW52ZXIlMjBza3lsaW5lJTIwbmlnaHQlMjBuZW9ufGVufDB8fHx8MTc4NzE2NTkyOXww&ixlib=rb-4.1.0&q=85",
  cosplayHero:
    "https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?auto=format&fit=crop&w=1600&q=80",
  spiderPunk: "https://images.pexels.com/photos/19653194/pexels-photo-19653194.jpeg",
  cosplay:
    "https://images.unsplash.com/photo-1595271444083-08084c6857c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxjb3NwbGF5JTIwZmFzaGlvbiUyMG5lb24lMjBjeWJlcnB1bmt8ZW58MHx8fHwxNzg3MTY1OTI5fDA&ixlib=rb-4.1.0&q=85",
  mocktail: "https://images.pexels.com/photos/6940092/pexels-photo-6940092.jpeg",
  mocktail2:
    "https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=1200&q=80",
  graffiti:
    "https://images.unsplash.com/photo-1604716053460-3f66248bf8de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxncmFmZml0aSUyMHN0cmVldCUyMGFydCUyMG11cmFsJTIwY29sb3JmdWx8ZW58MHx8fHwxNzg3MTczMzA5fDA&ixlib=rb-4.1.0&q=85",
  concert:
    "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1200&q=80",
  streetwear:
    "https://images.unsplash.com/photo-1552346154-21d32810aba3?auto=format&fit=crop&w=1200&q=80",
};

export const EVENT_DATE = new Date("2026-09-19T16:00:00-06:00");
